/**
 * Route prefixes under which the merged "Cerca Freelancer" sidebar item
 * (the find-candidates hub) should render as active. Covers the hub itself,
 * the two old job-offer URLs (`/job-offers/create` and `/job-offers/new`, now
 * redirects to the AI chat), and the active-search flow
 * (`/search/freelancers/*`). Deliberately excludes `/ats`.
 */
const FIND_CANDIDATES_ACTIVE_PREFIXES = [
  "/profile/company/find-candidates",
  "/profile/company/job-offers",
  "/profile/company/search/freelancers",
] as const;

export const isFindCandidatesNavActive = (pathname: string): boolean =>
  FIND_CANDIDATES_ACTIVE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
